import React, { useContext, useState } from "react";
import { Modal, Select, Row, Col, Form, Upload, Input, Radio } from "antd";
import { useQuery } from "react-query";
import stateDistrictMapping from "../../assets/data/Indian_district_State.json";
import statePCMapping from "../../assets/data/state_pc_mapping.json";
import ApprovaContext from "../../context/approvalContext";
import TextArea from "antd/es/input/TextArea";
import uploadCloud from "../../assets/svg/uploadCloud.svg";
import { FileFilled } from "@ant-design/icons";
import { AiOutlineClose } from "react-icons/ai";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { ToastContainer, toast } from "react-toastify";

const { Option } = Select;

const AddElectionModeShape = ({ isOpen, id, setShowStateShape }) => {
  const [form] = Form.useForm();
  const axiosInstance = useAxiosInstance();
  const approvaContext = useContext(ApprovaContext);
  const [radioValue, setRadioValue] = useState("assembly");
  const [fileList, setFileList] = useState([]);

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = 1951; year <= currentYear; year++) {
    years.push(year);
  }

  const [inputValues, setInputValues] = useState({
    state: null,
    district: null,
    constituency: null,
    pcName: null,
    year: null,
    description: "",
    boundaries: []
  });

  const closeModal = () => {
    approvaContext.updateOpenModal(false);
    form.resetFields();
    setShowStateShape(false);
    handleResetFile();
    setInputValues({
      state: null,
      district: null,
      constituency: null,
      pcName: null,
      year: null,
      description: "",
      boundaries: []
    });
  };

  const handleResetFile = () => {
    setInputValues((prev) => ({ ...prev, boundaries: [] }));
    setFileList([]);
  };

  const stateOptions = Object.keys(stateDistrictMapping).map((state) => ({
    value: state,
    label: state
  }));

  const districtOptions = inputValues.state
    ? stateDistrictMapping[inputValues.state].map((district) => ({
        value: district,
        label: district
      }))
    : [];

  const pcOptions = inputValues.state
    ? statePCMapping[inputValues.state].map((pcName) => ({
        value: pcName,
        label: pcName
      }))
    : [];

  // ---------- handleChange like in ConstituencyTabs ----------
  // const handleChange = (value, name) => {
  //   if (name === "state") {
  //     // reset district + constituency
  //     setInputValues((prev) => ({
  //       ...prev,
  //       state: value,
  //       district: null,
  //       constituency: null
  //     }));
  //     form.setFieldsValue({
  //       district: undefined,
  //       constituency: undefined
  //     });
  //     return;
  //   }

  //   if (name === "district") {
  //     // reset constituency
  //     setInputValues((prev) => ({
  //       ...prev,
  //       district: value,
  //       constituency: null
  //     }));
  //     form.setFieldsValue({
  //       constituency: undefined
  //     });
  //     return;
  //   }

  //   setInputValues((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (value, name) => {
    if (name === "state") {
      setInputValues((prev) => ({
        ...prev,
        state: value,
        district: null,
        constituency: null,
        pcName: null
      }));
      form.setFieldsValue({
        district: undefined,
        constituency: undefined,
        pcName: undefined
      });
      return;
    }

    if (name === "district") {
      setInputValues((prev) => ({
        ...prev,
        district: value,
        constituency: null
      }));
      form.setFieldsValue({ constituency: undefined });
      return;
    }

    setInputValues((prev) => ({ ...prev, [name]: value }));
  };

  // const handleRadioChange = (e) => {
  //   const value = e.target.value;
  //   setRadioValue(value);

  //   if (value === 2) {
  //     setInputValues((prev) => ({
  //       ...prev,
  //       district: null,
  //       constituency: null
  //     }));
  //     form.setFieldsValue({
  //       district: undefined,
  //       constituency: undefined
  //     });
  //   } else {
  //     setInputValues((prev) => ({ ...prev, pcName: null }));
  //     form.setFieldsValue({ pcName: undefined });
  //   }
  // };

  // ---------- useQuery: fetch constituencies by state & district ----------
  
  const handleRadioChange = (e) => {
    const value = e.target.value;
    setRadioValue(value);

    if (value === "assembly") {
      setInputValues((prev) => ({
        ...prev,
        pcName: null
      }));
      form.setFieldsValue({ pcName: undefined });
    }

    if (value === "parliamentary") {
      setInputValues((prev) => ({
        ...prev,
        district: null,
        constituency: null
      }));
      form.setFieldsValue({
        district: undefined,
        constituency: undefined
      });
    }

    if (value === "state") {
      setInputValues((prev) => ({
        ...prev,
        district: null,
        constituency: null,
        pcName: null
      }));
      form.setFieldsValue({
        district: undefined,
        constituency: undefined,
        pcName: undefined
      });
    }
  };

  const fetchConstituencyByStateDistrict = async ({ queryKey }) => {
    const [, state, district] = queryKey;
    if (!state || !district) return [];

    const response = await axiosInstance.get(
      `api/constituency/getAllConstituency?state=${state}&district=${district}`
    );

    return response?.data?.data?.data || response?.data?.data || [];
  };

  const {
    data: constituencyList = [],
    isLoading: isConstituencyLoading
  } = useQuery(
    ["constituencies-by-state-district", inputValues.state, inputValues.district],
    fetchConstituencyByStateDistrict,
    {
      enabled: !!inputValues.state && !!inputValues.district,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  const constituencyOptions = constituencyList.map((item) => ({
    value:
      item?._id ||
      item?.constituency_id ||
      item?.constituency_name ||
      item?.name,
    label:
      item?.name ||
      item?.constituency_name ||
      item?.pc_name ||
      item?.constituency ||
      String(item)
  }));

  const handleGeoFileUpload = async (data) => {
    try {
      const response = await axiosInstance.post(
        `/api/electionMode/createShapeFile/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      toast.success("State Shape Uploaded Successfully");
      closeModal();
      return response?.data?.data;
    } catch (error) {
      console.error("GeoJSON upload failed:", error.message);
      toast.error("File upload failed");
      return null;
    }
  };

  const handleSubmitForm = () => {
    const data = {
      state: inputValues?.state,
      district: radioValue === "assembly" ? inputValues?.district : null,
      constituency: radioValue === "assembly" ? inputValues?.constituency : null,
      pcName: radioValue === "parliamentary" ? inputValues?.pcName : null,
      year: inputValues?.year,
      description: inputValues?.description,
      boundaries: inputValues?.boundaries[0]?.originFileObj,
      shapeType: radioValue // "assembly" | "parliamentary" | "state"
    };

    handleGeoFileUpload(data);
  };

  return (
    <>
      {isOpen && (
        <Modal
          className="add-user-modal"
          open={isOpen}
          onCancel={closeModal}
          width={1040}
          maskClosable={false}
          footer={[
            <button
              key="add-approval-shape"
              form="approval-shape-form"
              type="submit"
              className="add-user-btn"
              style={{ width: "auto" }}
            >
              Add Election Mode Shape
            </button>
          ]}
        >
          <ToastContainer />
          <Form
            form={form}
            id="approval-shape-form"
            onFinish={handleSubmitForm}
            className="modal-body-container"
          >
            <div className="user-info-modal">
              <div className="modal-title">
                <h3>Add State Shape</h3>
              </div>
            </div>
            <div className="modal-wrapper-body constituency-form">
              <div className="model-wrapper">
                <div className="modal-wrapper-content">
                  <h4>State Shape Information</h4>
                  <Radio.Group onChange={handleRadioChange} value={radioValue}>
                    <Radio value="assembly">Assembly</Radio>
                    <Radio value="parliamentary">Parliamentary</Radio>
                    <Radio value="state">State</Radio>
                  </Radio.Group>
                  <Row className="add-modal-row mt-5 mb-2">
                    <Col span={8}>
                      <label>
                        Select State<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="state"
                        rules={[
                          { required: true, message: "Please Select State" }
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "state")}
                          options={stateOptions}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </Col>

                    {radioValue==="assembly" && <Col span={8} offset={2}>
                      <label>
                        Select District<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="district"
                        rules={[
                          { required: true, message: "Please Select District" }
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "district")}
                          options={districtOptions}
                          disabled={!inputValues.state}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          placeholder={
                            inputValues.state
                              ? "Select District"
                              : "Please select state first"
                          }
                        />
                      </Form.Item>
                    </Col>}

                    {radioValue==="assembly" && <Col span={8} offset={2}>
                      <label>
                        Select Constituency
                        <span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="constituency"
                        rules={[
                          {
                            required: true,
                            message: "Please Select Constituency"
                          }
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(value) =>
                            handleChange(value, "constituency")
                          }
                          options={constituencyOptions}
                          disabled={
                            !inputValues.state || !inputValues.district
                          }
                          loading={isConstituencyLoading}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          placeholder={
                            inputValues.state && inputValues.district
                              ? "Select Constituency"
                              : "Please select state and district first"
                          }
                        />
                      </Form.Item>
                    </Col>}

                    {radioValue === "assembly" && (
                      <Col span={22} className="mt-2">
                        <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                          Each GeoJSON feature will be split by its{" "}
                          <strong>Ward_Name</strong> property (falls back to{" "}
                          <strong>Name</strong> / <strong>NAME</strong> if not
                          present).
                        </span>
                      </Col>
                    )}

                    {radioValue==="parliamentary" && <Col span={8} offset={2}>
                      <label>
                        Select Parliamentary<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="pcName"
                        rules={[
                          { required: true, message: "Please Select Parliamentary" }
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "pcName")}
                          options={pcOptions}
                          disabled={!inputValues.state}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          placeholder={
                            inputValues.state
                              ? "Select Parliamentary"
                              : "Please select state first"
                          }
                        />
                      </Form.Item>
                    </Col>}   

                  </Row>

                  <Row className="add-modal-row mb-2">
                    <Col span={8} offset={2}>
                      <label>
                        Year<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="year"
                        rules={[
                          { required: true, message: "Please Select Year" }
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "year")}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toString()
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {years.map((year) => (
                            <Option key={year} value={year}>
                              {year}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="add-modal-row mb-2">
                    <Col span={18}>
                      <label>
                        Description<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="description"
                        rules={[
                          {
                            required: true,
                            message: "Please enter the Description"
                          }
                        ]}
                      >
                        <TextArea
                          rows={2}
                          name="description"
                          onChange={(e) =>
                            handleChange(e.target.value, "description")
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="add-modal-row mb-2">
                    <Col span={22}>
                      <h3>
                        Election Mode Shape File (GeoJSON)
                        <span className="required-field">*</span>
                      </h3>
                      <Form.Item
                        name="boundaries"
                        rules={[
                          {
                            required: true,
                            message: "Please upload the shape file"
                          }
                        ]}
                      >
                        <div className="constituency-upload-file">
                          <Upload.Dragger
                            key="select-file"
                            name="boundaries"
                            beforeUpload={() => false}
                            fileList={fileList}
                            onChange={(info) => {
                              const { file, fileList } = info;
                              if (file.status === "done") {
                                setFileList([file]);
                              } else {
                                setFileList(fileList);
                              }
                              handleChange(fileList, "boundaries");
                            }}
                            className="custom-file-upload"
                            accept=".json"
                          >
                            {inputValues?.boundaries.length > 0 ? (
                              <div className="fileUpload">
                                <div className="text-right">
                                  <button
                                    onClick={handleResetFile}
                                    className="reset-button font-bold"
                                  >
                                    <AiOutlineClose />
                                  </button>
                                </div>
                                <div className="flex file-icon">
                                  <FileFilled />
                                  <p>{inputValues?.boundaries[0]?.name}</p>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <img src={uploadCloud} alt="" className="m-auto" />
                                <p className="ant-upload-text">
                                  Select a file or drag and drop
                                </p>
                                <p className="ant-upload-text">
                                  GeoJSON file size no more than 10MB
                                </p>
                                <span className="select-file">Select File</span>
                              </div>
                            )}
                          </Upload.Dragger>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default AddElectionModeShape;
